<template>
    <v-card color="" elevation="0" class="px-4">
        <v-divider></v-divider>
        <div class="d-flex pt-3 pb-7 mt-2">
            <v-text-field style="flex: 0 1 300px" v-model="search" append-icon="mdi-magnify" outlined
                :label="$t('products.sessions.search')" single-line dense hide-details></v-text-field>
            <v-spacer></v-spacer>
            <div class="d-flex">
                <v-tooltip v-if="!enabled" bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="enabled = !enabled" v-bind="attrs" v-on="on" class="py-5 ml2"
                            elevation="0"><v-icon>mdi-sort</v-icon></v-btn>
                    </template>
                    <span>{{ $t('products.sessions.changeSort') }}</span>
                </v-tooltip>
                <v-btn v-else @click="updateOrder()" class="py-5 ml2" color="success" elevation="0">{{
                    $t('common.save') }}</v-btn>

                <v-btn color="success" @click="add()" class="py-5 ml-2" elevation="0">{{ $t('common.add') }}</v-btn>
            </div>

        </div>

        <v-card outlined>

            <v-data-table hide-default-footer disable-pagination sort-by="sortIndex" item-key="id" :sort-desc="false"
                :headers="headers" :items="documents" :items-per-page="10" :search="search" class="elevation-1">
                <template v-slot:body="props">
                    <draggable :list="props.items" tag="tbody" :disabled="!enabled" :move="onMove"
                        @end="result = props.items">
                        <tr v-for="(item, index) in props.items" :key="index">
                            <!-- <td>{{ item.sortIndex + 1 }}</td> -->

                            <td>{{ item.title }}</td>
                            <td> {{ item.asus.length }} </td>
                            <td> {{ item.packs.length }} </td>

                            <td><v-chip label small v-if="item.status && item.status == 1" color="success">{{
                                $t('common.active') }}</v-chip>
                                <v-chip label small v-else>{{ $t('products.sessions.inactive') }}</v-chip>
                            </td>
                            <td>{{ item.updatedOn | dateTimeS }}</td>
                            <td align="right"><v-btn class="mr-1" icon @click="editItem(item)"><v-icon
                                        small>mdi-pencil-outline</v-icon></v-btn>
                                <v-btn @click="replicate(item)" icon class="mr-1"><v-icon
                                        small>mdi-content-copy</v-icon></v-btn>
                            </td>
                        </tr>




                        <!-- <template v-slot:[`item.image`]="{ item }">
                    <v-avatar size="38">
                        <v-img width="38" height="38" :src="item.image"></v-img>
                    </v-avatar>
                </template>

        <template v-slot:[`item.dueDate`]="{ item }">
                    <template v-if="item.dueDate">
                        {{ item.dueDate | dateCompact }}
                    </template>
        <template v-else>{{ $t('products.sessions.dontValidity') }}</template>
        </template>
        <template v-slot:[`item.finalPrice`]="{ item }">
                    {{ $n(item.finalPrice, 'currency') }}
                </template>
        <template v-slot:[`item.cpm`]="{ item }">
                    {{ $n(item.cpm, 'currency') }}
                </template>
        <template v-slot:[`item.asus`]="{ item }">
                    {{ item.asus.length }}
                </template>
        <template v-slot:[`item.status`]="{ item }">
                    <v-chip label small v-if="item.status && item.status == 'published'"
                        color="success">{{ $t('common.active') }}</v-chip>
                    <v-chip label small v-else>{{ $t('products.sessions.inactive') }}</v-chip>
                </template>
        <template v-slot:[`item.id`]="{ item }">
                    <v-btn icon small @click="editItem(item)"><v-icon>mdi-pencil-outline</v-icon></v-btn>
                </template> -->

                    </draggable>
                </template>

            </v-data-table>
        </v-card>

        <v-dialog width="1024" v-model="show">
            <SessionForm :packs="documentsPacks" :asus="documentsAsus" v-if="show" :show="show" :snap="snap" @show-form="show = $event"
                @reload-documents="loadDocuments()">
            </SessionForm>
        </v-dialog>
        <v-dialog width="640" v-model="sorter.show">
            <v-card class="mx-auto" v-if="sorter.show">
                <SorterArray :snap="documents"></SorterArray>
            </v-card>
        </v-dialog>

    </v-card>
</template>
<script>
import moment from 'moment'
import config from '@/store/config'
import { mapActions } from 'vuex';
import { mapState } from "vuex";
import { initializeApp } from "firebase/app";


// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import draggable from 'vuedraggable'

import { doc, setDoc, getFirestore, collection, query, getDocs } from "firebase/firestore";
import SorterArray from '../customize/SorterArray.vue';

import SessionForm from './SessionForm.vue'

// import Sortable from 'sortablejs/modular/sortable.complete.esm.js';
export default {
    name: "SessionsList",
    components: { SessionForm, SorterArray, draggable },
    data() {
        return {
            listToSave: [],
            documentsAsus: [],
            loadingAsus: false,
            documentsPacks: [],
            loadingPacks: false,
            result: [],
            newOrder: [],
            enabled: false,
            reRender: 0,
            dragNdrop: [],
            sorter: {
                show: false
            },
            loading: true,
            show: false,
            snap: null,
            search: this.$route.query.q ? this.$route.query.q : "",
            documents: [],


        };
    },
    mounted() {
        this.loadDocuments();
        this.loadAsus()
        this.loadPacks()
    },
    watch: {
        "$route.params.tab"(value) {
            if (value != 1)
                this.search = this.$route.query.q ? this.$route.query.q : "";
        }
    },

    computed: {
        ...mapState("groupStores", [
            "masterStore",
        ]),
        headers() {
            return [
                // {
                //     text: "index",
                //     sortable: true,
                //     value: "sortIndex"
                // },

                {
                    text: this.$t('products.sessions.title'),
                    align: "start",
                    sortable: false,
                    value: "title",
                },
                {
                    text: this.$t('products.sessions.asus'), value: "asus", sortable: false,
                },
                {
                    text: this.$t('products.sessions.packs'), value: "packs", sortable: false,
                },

                // {
                //     text: this.$t('products.sessions.CPM'), value: "cpm", sortable: false,
                // },                
                {
                    text: this.$t('products.sessions.status'), value: "status", sortable: false,
                },
                {
                    text: this.$t('products.sessions.updatedOn'), value: 'updatedOn', sortable: false
                },
                {
                    text: "", value: "id", sortable: false,
                }
                // { text: "", value: "actions", sortable: false }
            ]
        }
    },
    methods: {

        ...mapActions("snackbar", ["showSnack"]),
        onMove({ relatedContext, draggedContext }) {
            console.log('relatedContext', relatedContext)
            console.log('draggedContext', draggedContext)
            const relatedElement = relatedContext.element;
            const draggedElement = draggedContext.element;
            return (
                (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
            )
        },

        onEnd(e) {
            console.log('Event on End', e)
            const res = []
            e.relatedContext.list.forEach((item) => {
                res.push(item.id)
            })
            console.log('res', res)
            this.newOrder = res
        },
        updateOrder() {
            if(this.result.length){
                this.result.forEach((Form, i) => {
                    Form.order = i
                    Form.updatedOn = moment().format()
                    const firebase = initializeApp(config);
                    const db = getFirestore(firebase);
                    setDoc(doc(db, "productSessions", Form.id), Form).then(() => {

                    })
                })
                this.enabled = false


            }
            // const res = []
            // this.result.forEach((item) => {
            //     res.push(item.id)
            // })
            // const firebase = initializeApp(config);
            // const db = getFirestore(firebase);

            // const masterRef = doc(db, "stores", this.masterStore.id);
            // updateDoc(masterRef, {
            //     "packagesSorter": res
            // }).then(() => {
            //     this.showSnack({
            //         text: this.$t("common.messages.sortSaved"),
            //         color: "success",
            //         timeout: 3800,
            //         icon: "mdi-check",
            //     });

            //     this.enabled = !this.enabled
            // })


           

        },
        joinItems(items) {
            if (Array.isArray(items)) {
                return items.join(', ')
            }
            else
                return ''
        },
        editItem(item) {
            console.log('snap to edit', item)
            this.snap = JSON.parse(JSON.stringify(item))
            this.show = true
        },
        replicate(item) {
            this.snap = JSON.parse(JSON.stringify(item))
            this.snap.id = null
            this.show = true
        },
        add() {
            this.snap = null
            this.show = true
        },
        initSortable() {
            let table = document.querySelector("tbody");
            const _self = this;
            // this way we avoid data binding
            _self.dragNdrop = JSON.parse(JSON.stringify(_self.documents));

            Sortable.create(table, {
                onEnd({
                    newIndex,
                    oldIndex
                }) {

                    _self.dragNdrop.splice(
                        newIndex,
                        0,
                        ..._self.dragNdrop.splice(oldIndex, 1)
                    );
                    console.log('_self.dragNdrop', _self.dragNdrop);
                }
            });
        },
        loadPacks() {
            this.loadingPacks = true
            const firebase = initializeApp(config);
            const db = getFirestore(firebase);
            const q = query(collection(db, "packages"));
            const querySnapshot = getDocs(q);
            const documents = [];
            querySnapshot.then((docs) => {
                docs.forEach((doc, i) => {
                    // format
                    let format = doc.data();
                    // if (!this.$root.auth.profile.whitelabelId || format.stores.includes(this.$root.auth.profile.whitelabelId)) {
                    //     if (!sortIndex.length) {
                    //         format.sortIndex = i
                    //     }
                    //     else {
                    //         format.sortIndex = 1000
                    //         sortIndex.forEach((item, index) => {
                    //             if (item == format.id) {
                    //                 console.log(`O item ${item} é index ${index}`)
                    //                 format.sortIndex = index
                    //             }
                    //         })
                    //     }
                    //     format.storesText = format.hasOwnProperty('stores') && format.stores.length ? format.stores.join(', ') : ''
                    //     format.updatedOn = format.hasOwnProperty('updatedOn') && format.updatedOn ? format.updatedOn : ''
                    // }
                    format.id = doc.id
                    documents.push(format);
                });

                // documents.sort((p1, p2) => (p1.sortIndex > p2.sortIndex) ? 1 : (p1.sortIndex < p2.sortIndex) ? -1 : 0);
                this.documentsPacks = documents.sort((p1, p2) => (p1.sortIndex > p2.sortIndex) ? 1 : (p1.sortIndex < p2.sortIndex) ? -1 : 0);

                // this.documents = documents;
                this.loadingPacks = false;
                // this.initSortable()
            });
        },
        loadAsus() {
            const snap = {};
            this.loadingAsus = true;
            const firebase = initializeApp(config);
            const db = getFirestore(firebase);
            const q = query(collection(db, "asus"));
            const querySnapshot = getDocs(q);
            const documents = [];
            querySnapshot.then((docs) => {
                docs.forEach((document) => {
                    if (!this.$root.auth.profile.whitelabelId || document.data().store == this.$root.auth.profile.whitelabelId) {

                        if (
                            (this.type == "selectToPackage" && document.data().status) ||
                            this.type != "selectToPackage"
                        ) {
                            const format = document.data().format;
                            const formatParts = [];
                            format.print.split(" ").forEach((p) => {
                                // /const kl = `format.${format[p]}`
                                const ktv = this.$t(`format.${format[p]}`);
                                const noPoint = !ktv.includes(".");
                                //console.log('spli',  format.print.split(' '))
                                // console.log('format[k]', ktv)
                                // console.log('noPoint', noPoint)

                                // console.log('format[te]', this.$te(kl))
                                // console.log('format[t]', this.$t(kl))

                                const el =
                                    p == "metric"
                                        ? noPoint
                                            ? this.$t(`format.${format[p]}`)
                                            : format[p]
                                        : format[p];
                                formatParts.push(el);
                                //console.log('el', el)
                            });

                            // discount
                            const discount =
                                document.data().rules.pricing.unityPrice !=
                                    document.data().rules.pricing.price
                                    ? this.$n(
                                        (1 -
                                            document.data().rules.pricing.price /
                                            document.data().rules.pricing.unityPrice) *
                                        100
                                    )
                                    : null;

                            // mediatype
                            const mediaType = {
                                value: document.data().mediaType.parents,
                                text: this.$t(
                                    `format.mediaTypes.${document.data().mediaType.parents}`
                                ),
                            };

                            // location
                            const locationsSnap = document.data().locations;
                            const locationsSearch = {};
                            locationsSnap.forEach((location) => {
                                const key = `${location.city} - ${location.state} - ${location.country}`;
                                if (!locationsSearch.hasOwnProperty(key))
                                    locationsSearch[key] = { key: key, ...location };
                            });

                            // time
                            const dta = document.data();
                            const time = dta.hasOwnProperty.hasOwnProperty("timeSlot")
                                ? dta.timeSlot
                                : { min: null, max: null };
                            const timeSlot = [];
                            let timeText = null;
                            if (time.min !== null)
                                timeSlot.push(moment(time.min, "X").format("LT"));
                            else timeSlot.push("-");

                            if (time.max !== null)
                                timeSlot.push(moment(time.max, "X").format("LT"));
                            else timeSlot.push("-");

                            if (timeSlot[0] != "-" && timeSlot[1] != "-")
                                timeText = `${time.type} ${this.$tc(
                                    "format.timeRange",
                                    timeSlot[0],
                                    { from: timeSlot[0], to: timeSlot[1] }
                                )}`;
                            if (timeSlot[0] != "-" && timeSlot[1] == "-")
                                timeText = `${time.type} ${this.$tc(
                                    "format.timeFrom",
                                    timeSlot[0],
                                    { from: timeSlot[0] }
                                )}`;
                            if (timeSlot[0] == "-" && timeSlot[1] != "-")
                                timeText = `${time.type} ${this.$tc(
                                    "format.timeTo",
                                    timeSlot[1],
                                    { to: timeSlot[1] }
                                )}`;

                            // locations
                            const locations = [];
                            for (let i = 0; i < document.data().locations.length; i++) {
                                if (i == 2) break;
                                else locations.push(document.data().locations[i].city);
                            }
                            const more =
                                document.data().locations.length > 3
                                    ? `<strong>+ ${document.data().locations.length - 3
                                    } cidades</strong>.`
                                    : "";

                            const docDataT = JSON.parse(JSON.stringify(document.data()));
                            delete docDataT.interests;

                            const data = {
                                id: document.id,

                                computed: {
                                    coverage: document.data().coverage ? document.data().coverage.join(', ') : '',
                                    formatText: formatParts.join(" "),
                                    discount: discount,
                                    time: timeText,
                                    mediaType: mediaType,
                                    locationsText: ` ${locations.join(", ")} ${this.$tc(
                                        "common.location",
                                        document.data().locations.length - 2 > 0 ? document.data().locations.length - 2 : 0,
                                        { count: document.data().locations.length - 2 > 0 ? document.data().locations.length - 2 : 0 }
                                    )}`,
                                    locationsSearch: locationsSearch,
                                },
                                interests: document
                                    .data()
                                    .interests.filter((item) => item !== ""),
                                ...docDataT,
                            };
                            if (this.type == "selectToPackage") {
                                data.selected = snap.hasOwnProperty(data.sku);
                                data.insertions = snap.hasOwnProperty(data.sku)
                                    ? snap[data.sku].insertions
                                    : data.rules.insertions.min *
                                    (this.calcTotalDaysPeriod(data)
                                        ? this.calcTotalDaysPeriod(data)
                                        : data.rules.periods.min);
                                data.duration = snap.hasOwnProperty(data.sku)
                                    ? snap[data.sku].duration
                                    : this.totalDays
                            }
                            documents.unshift(data);
                        }
                    }

                });

                    this.documentsAsus = documents;
                    this.loadingAsus = false;
            });
        },
        loadDocuments() {
            let sortIndex = []

            this.show = false
            this.loading = true;
            const firebase = initializeApp(config);
            const db = getFirestore(firebase);
            const q = query(collection(db, "productSessions"));
            const querySnapshot = getDocs(q);
            const documents = [];
            querySnapshot.then((docs) => {
                docs.forEach((doc, i) => {
                    // format
                    let format = doc.data();
                    // if (!this.$root.auth.profile.whitelabelId || format.stores.includes(this.$root.auth.profile.whitelabelId)) {
                    //     if (!sortIndex.length) {
                    //         format.sortIndex = i
                    //     }
                    //     else {
                    //         format.sortIndex = 1000
                    //         sortIndex.forEach((item, index) => {
                    //             if (item == format.id) {
                    //                 console.log(`O item ${item} é index ${index}`)
                    //                 format.sortIndex = index
                    //             }
                    //         })
                    //     }
                    //     format.storesText = format.hasOwnProperty('stores') && format.stores.length ? format.stores.join(', ') : ''
                    format.updatedOn = format.hasOwnProperty('updatedOn') && format.updatedOn ? format.updatedOn : ''
                    format.id = doc.id
                    documents.push(format);
                    // }
                });

                this.documents = documents.sort((p1, p2) => (p1.order > p2.order) ? 1 : (p1.order < p2.order) ? -1 : 0);

                // this.documents = documents;
                this.loading = false;
                // this.initSortable()
            });
        }
    },
}
</script>

<style lang="scss" scoped></style>